import React from 'react';
import { Routes, Route, useParams, Navigate } from 'react-router-dom';
import RewriteUrlComponent from '../components/RewriteUrlComponent';
import MarketPrice from '../pages/marketPrice/index';
import MarketPriceFilterCatalogue from '../pages/marketPrice/marketPricesFilterCatalogue';
import TextToSpeech from '../pages/TextToSpeech/index.jsx';
import TrainingData from '../pages/TrainingData/index.jsx';
import DianogticResult from '../pages/TrainingData/DianogticResult';
import TrainingDataOA from '../pages/TrainingData/TrainingDataOA';
import DianogticResultOA from '../pages/TrainingData/DianogticResultOA';
import MarKetPriceDetail from 'pages/marketPriceDetail/index';
import ContributeForm from 'pages/contribute_form/index';
import NPK from '../pages/NPK/index';
import CallExpert from 'pages/callExpert/index';
import HomeTraceabilites from 'pages/traceability';
import ListTraceabilites from 'pages/traceability/components/listTraceabilites';
import NewTraceability from 'pages/traceability/components/newTraceability';
import CodeTraceabilites from 'pages/traceability/components/partials/codeTraceability';
import Weather from 'pages/weather/index';
import DetailsTraceabilities from 'pages/traceability/components/partials/detailsTraceability';

function ModuleRedirect() {
  const { slug = '', '*': rest = '' } = useParams();
  const targetPath = `/chuyen-muc/${slug}${rest ? '/' + rest : ''}`;
  return <Navigate to={targetPath} replace />;
}

function ModulesRoutes() {
  return (
    <Routes>
      {/* Chuyển hướng dynamic từ /modules/:slug/* sang /chuyen-muc/:slug/* */}
      <Route path="/modules/:slug/*" element={<ModuleRedirect />} />

      {/* Ví dụ chuyển hướng cụ thể cho từng nhóm route */}
      <Route path="/chuyen-muc/npk" element={<NPK />} />
      <Route path="/modules/npk" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/gia-ca-thi-truong" element={<MarketPrice />} />
      <Route path="/chuyen-muc/mat-hang-gia-ca-thi-truong" element={<MarketPriceFilterCatalogue />} />
      <Route path="/modules/gia-ca-thi-truong" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/thong-tin-gia-ca-thi-truong/:marketId" element={<MarKetPriceDetail />} />
      <Route path="/modules/thong-tin-gia-ca-thi-truong/:marketId" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/gia-ca-thi-truong/dong-gop" element={<ContributeForm />} />
      <Route path="/modules/gia-ca-thi-truong/dong-gop" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/goi-chuyen-gia" element={<CallExpert />} />
      <Route path="/modules/goi-chuyen-gia" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/giong-doc" element={<TextToSpeech />} />
      <Route path="/modules/giong-doc" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/nhan-dang-sau-benh" element={<TrainingData />} />
      <Route path="/modules/nhan-dang-sau-benh" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/nhan-dang-sau-benh/ket-qua-chan-doan" element={<DianogticResult />} />
      <Route path="/modules/nhan-dang-sau-benh/ket-qua-chan-doan" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/nhan-dang-sau-benh-oa" element={<TrainingDataOA />} />
      <Route path="/modules/nhan-dang-sau-benh-oa" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/nhan-dang-sau-benh-oa/ket-qua-chan-doan" element={<DianogticResultOA />} />
      <Route path="/modules/nhan-dang-sau-benh-oa/ket-qua-chan-doan" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/thoi-tiet" element={<Weather />} />
      <Route path="/modules/thoi-tiet" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc" element={<HomeTraceabilites />} />
      <Route path="/modules/truy-xuat-nguon-goc" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc/danh-sach" element={<ListTraceabilites />} />
      <Route path="/modules/truy-xuat-nguon-goc/danh-sach" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc/nhap-ma" element={<CodeTraceabilites />} />
      <Route path="/modules/truy-xuat-nguon-goc/nhap-ma" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc/tao-moi" element={<NewTraceability />} />
      <Route path="/modules/truy-xuat-nguon-goc/tao-moi" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc/chinh-sua" element={<NewTraceability />} />
      <Route path="/modules/truy-xuat-nguon-goc/chinh-sua" element={<RewriteUrlComponent />} />

      <Route path="/chuyen-muc/truy-xuat-nguon-goc/:traceabilityId" element={<DetailsTraceabilities />} />
      <Route path="/modules/truy-xuat-nguon-goc/:traceabilityId" element={<RewriteUrlComponent />} />
    </Routes>
  );
}

export default ModulesRoutes;
